import { createFileRoute } from '@tanstack/react-router'
import EditionGeneral from 'Edition/components/sections/General/EditionGeneral'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-misc')({
    component: EditionGeneral,
})
